import { NR2J_APPROVALS_CHANGED_EVENT } from './nr2jApprovals';

/** Rafraîchissement cross-vues NR2J (journal, listes, KPI, badges). */
export const NR2J_DATA_CHANGED_EVENT = 'clickorico:nr2j-data-changed';

/**
 * Notifie les vues ouvertes qu’une mutation métier a eu lieu.
 * Relance aussi le badge / file d’approbation sauf si opts.approvals === false.
 */
export function notifyNr2jDataChanged(detail = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(NR2J_DATA_CHANGED_EVENT, { detail }));
  if (detail.approvals !== false) {
    window.dispatchEvent(new Event(NR2J_APPROVALS_CHANGED_EVENT));
  }
}
